import { render, staticRenderFns } from "./Room5.vue?vue&type=template&id=71570fb8&scoped=true&"
import script from "./Room5.vue?vue&type=script&lang=ts&"
export * from "./Room5.vue?vue&type=script&lang=ts&"
import style0 from "./Room5.vue?vue&type=style&index=0&id=71570fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71570fb8",
  null
  
)

export default component.exports